"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.setup = void 0;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var token;
var blocketApiUrl;
var authenticationConfig = {};

var sleep = function sleep(timeInSeconds) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, timeInSeconds * 1000);
  });
};

var handleResponse = function handleResponse(response) {
  return response.ok ? response.json() : Promise.resolve(response.status);
};
/**
 * The ad cache will be indexed by adId, calls that only uses listId will not be locally cachable.
 */


var adCache = {};
var adCacheOrder = [];
var CACHE_LIMIT = 10;

var cacheAd = function cacheAd(ad) {
  if (!ad) {
    return undefined;
  }

  if (adCacheOrder.length > CACHE_LIMIT) {
    var key = adCacheOrder.shift();

    if (key) {
      delete adCache[key];
    }
  }

  adCache[ad.adId] = ad;
  adCacheOrder.push(ad.adId);
  return ad;
};

var setup = function setup(newToken, newBlocketApiUrl, newAuthenticationConfig) {
  token = newToken;
  blocketApiUrl = newBlocketApiUrl;
  authenticationConfig = newAuthenticationConfig;
};

exports.setup = setup;

var invalidateToken = function invalidateToken() {
  token = undefined;
};

var materializeToken = function materializeToken() {
  if (token) {
    return Promise.resolve(token);
  }

  var form = new URLSearchParams(_objectSpread(_objectSpread({}, authenticationConfig), {}, {
    grant_type: 'client_credentials'
  }));
  return fetch("".concat(blocketApiUrl, "/auth/v1/oauth/tokens"), {
    method: 'POST',
    body: form
  }).then(handleResponse).then(function (payload) {
    // eslint-disable-next-line camelcase
    token = payload === null || payload === void 0 ? void 0 : payload.access_token;
    return token;
  });
};

var call = function call(url) {
  return fetch("".concat(blocketApiUrl, "/search_bff/v2/content").concat(url), {
    headers: {
      Authorization: "Bearer ".concat(token)
    }
  }).then(handleResponse);
};

var fetchUsingAdId = function fetchUsingAdId(adId) {
  return call("/".concat(adId)).then(function (payload) {
    return payload === null || payload === void 0 ? void 0 : payload.data;
  });
};

var fetchUsingListId = function fetchUsingListId(listId) {
  return call("?list_id=".concat(listId)).then(function (payload) {
    var _payload$data;

    return payload === null || payload === void 0 ? void 0 : (_payload$data = payload.data) === null || _payload$data === void 0 ? void 0 : _payload$data[0];
  });
};

var camelCase = function camelCase(value) {
  return value.replace(/_./g, function (word) {
    return word[1].toUpperCase();
  });
};

var transformToCamelCase = function transformToCamelCase(data) {
  if (Array.isArray(data)) {
    return data.map(transformToCamelCase);
  }

  if (_typeof(data) === 'object' && data !== null) {
    return Object.entries(data).reduce(function (obj, _ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];

      key = camelCase(key);
      obj[key] = transformToCamelCase(value);
      return obj;
    }, {});
  }

  return data;
};

var normalizeAd = function normalizeAd(ad) {
  var _ad, _ad$parameterGroups;

  if (!ad) {
    return undefined;
  }

  ad = transformToCamelCase(ad);
  /**
   * Index the parameter groups and parameters by id
   */
  // eslint-disable-next-line no-shadow

  var parameterGroupsById = (_ad = ad) === null || _ad === void 0 ? void 0 : (_ad$parameterGroups = _ad.parameterGroups) === null || _ad$parameterGroups === void 0 ? void 0 : _ad$parameterGroups.reduce(function (obj, current) {
    // eslint-disable-next-line no-shadow
    var parametersById = current.parameters.reduce(function (obj, current) {
      obj[current.id] = current;
      return obj;
    }, {});
    obj[current.type] = parametersById;
    return obj;
  }, {});

  if (parameterGroupsById) {
    ad.parameterGroupsById = parameterGroupsById;
  }

  return ad;
};
/**
 * Fetch a ad using adId or listId, the response will be a
 * `[string: fetching|haveAd, ad: ad|promise]`.
 *
 * Note: In some cases this function will be called in a `onClick` handler on a exit link, due to
 * that we have to avoid creating a promise, since those are always resolved on the next browser
 * tick even if we use a immediate `Promise.resolve`. The next tick happens after the user have left
 * the page. :(
 */


var fetchAd = function fetchAd(adId, listId) {
  var attempt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  if (attempt > 3) {
    return Promise.reject(new Error("Could not fetch ad ".concat(adId || listId, " after several attempts.")));
  }

  var ad = adCache === null || adCache === void 0 ? void 0 : adCache[adId];

  if (ad) {
    return ['haveAd', ad];
  }

  var promise = materializeToken().then(function () {
    return adId ? fetchUsingAdId(adId) : fetchUsingListId(listId);
  }).then(normalizeAd).then(cacheAd)["catch"](function (error) {
    if (error === 401) {
      invalidateToken(); // The first retry should be done as fast as possible.

      var nextAttempt = attempt + 1;
      return sleep(attempt).then(function () {
        return fetchAd(adId, listId, nextAttempt);
      });
    }

    return undefined;
  });
  return ['fetching', promise];
};

var _default = fetchAd;
exports["default"] = _default;
//# sourceMappingURL=fetchAd.js.map